export type TokenKind = 'plain' | 'comment' | 'string' | 'tag' | 'keyword' | 'number' | 'function' | 'attr' | 'property'

export type Token = {
    kind: TokenKind
    text: string
}

const PATTERN = /(\/\/.*$)|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|`(?:[^`\\]|\\.)*`)|(<\/?[A-Za-z][\w-]*|\/?>)|\b(import|from|export|function|const|let|return|await|async|new|if|true|false|null)\b|\b(\d+(?:\.\d+)?)\b|([A-Za-z_$][\w$]*)(?=\()|([A-Za-z_][\w-]*)(?==)|([A-Za-z_$][\w$]*)(?=:\s)/g

const KINDS: TokenKind[] = ['comment', 'string', 'tag', 'keyword', 'number', 'function', 'attr', 'property']

/** Splits one line of HTML or JavaScript into coloured tokens. Small on purpose: it only has to read our own snippets. */
export const tokenizeLine = (line: string): Token[] => {
    const tokens: Token[] = []
    let cursor = 0

    PATTERN.lastIndex = 0

    for (const match of line.matchAll(PATTERN)) {
        const index = match.index ?? 0

        if (index > cursor) tokens.push({ kind: 'plain', text: line.slice(cursor, index) })

        const group = match.slice(1).findIndex(value => value !== undefined)
        tokens.push({ kind: KINDS[group] ?? 'plain', text: match[0] })
        cursor = index + match[0].length
    }

    if (cursor < line.length) tokens.push({ kind: 'plain', text: line.slice(cursor) })

    return tokens
}
